export default {
    APP_CONFIGURATION_JSON: {
        path: '/AppConfiguration.json',
        useConfigUrl: true,
    },
    QZ_CONFIGURATION_JSON: {
        path: '/qzConfig.json',
        useConfigUrl: true,
    },
};
